const data = [
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/Web-Development.png",
    title: "Web Development",
    target: "/services/web-development",
    classTo: "dropDownSingleItem three",
  },
  {
    img:
      "https://invozone.com/wp-content/uploads/2020/06/Mobile-Application.png",
    title: "Mobile Application",
    target: "/services/mob-application",
    classTo: "dropDownSingleItem three",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/DevOps-1.png",
    title: "DevOps",
    target: "/services/devops",
    classTo: "dropDownSingleItem three",
  },
  {
    img:
      "https://invozone.com/wp-content/uploads/2020/06/Software-Quality-Assurance.png",
    title: "Software Quality Assurance",
    target: "/services/qa",
    classTo: "dropDownSingleItem three",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/Data-Scraping-1.png",
    title: "Data Scraping",
    target: "/services/data-scrapping",
    classTo: "dropDownSingleItem three",
  },
  {
    img:
      "https://invozone.com/wp-content/uploads/2020/06/Big-Data-Data-Scince.png",
    title: "Big Data & Data Science",
    target: "/services/data-science",
    classTo: "dropDownSingleItem three",
  },
  {
    img: "https://invozone.com/wp-content/uploads/2020/06/Cryptography-IOT.png",
    title: "Cryptography & IOT",
    target: "/services/iot",
    classTo: "dropDownSingleItem three",
  },
  {
    img:
      "https://invozone.com/wp-content/uploads/2020/06/Product-Support-Services.png",
    title: "Product Support Services",
    target: "/services/support",
    classTo: "dropDownSingleItem three",
  },
  {
    img:
      "https://invozone.com/wp-content/uploads/2020/06/Branding-UI-UX-Designing.png",
    title: "Branding & UI/UX Designing",
    target: "/services/ui-ux",
    classTo: "dropDownSingleItem three",
  },
  {
    img:
      "https://invozone.com/wp-content/uploads/2020/06/Enterprise-software-development.png",
    title: "Enterprise Software Development",
    target: "/services/software-development",
    classTo: "dropDownSingleItem three",
  },
  {
    img:
      "https://invozone.com/wp-content/uploads/2020/06/Product-Managment.png",
    title: "Product Management",
    target: "/services/product-management",
    classTo: "dropDownSingleItem three",
  },
];

export default data;
